<template>
  <div class="container">
    <div class="block">
      <div class="content-inner-wrapper">
        <div class="serverInfo">
          <img :src="currServ.image | setDefaultMapImg" />
          <div class="serverDetails">
            <h4>{{ currServ.room_name }}</h4>
            <p>
              {{ currServ.room_type | getRoomType }}（{{
                currServ.player_max
              }}人）
            </p>
            <p>
              {{ currServ.stat | getState }}（{{
                currServ.expire_time | formatTime
              }}）
            </p>
            <van-tag
              :type="isWarnDay(currServ.expire_time) ? 'danger' : 'success'"
              >{{ currServ.expire_time | remainderTime }}</van-tag
            >
          </div>
        </div>
        <div class="serverDesc">
          <van-field label="简介：" label-width="0.6rem">
            <template #input>
              {{ currServ.desc }}
            </template>
          </van-field>
        </div>
        <h3>本月服务器数据</h3>
        <div class="serverDataList">
          <div
            class="serverDataItem"
            v-for="(item, index) in dataPanelList"
            :key="index"
          >
            <h4>{{ item.title }}</h4>
            <p class="itemVal">
              {{ item.value | formatMoney }}
              <em v-if="item.unit >= 10000">{{ item.unit }}</em>
            </p>
            <p class="itemTotal">
              累计{{ item.total | formatMoney
              }}<em v-if="item.unit >= 10000">{{ item.unit }}</em>
            </p>
          </div>
        </div>
        <h3>基础数据</h3>
        <date-selector
          v-model="baseDate"
          @change="baseDateChangeFn"
          :queryBtnClick="handleBaseDateBtnClicked"
        ></date-selector>
        <my-table :tableData="baseData" :tableField="baseDataField">
          <template slot-scope="scope" slot="default">
            <span v-if="scope.row.key == 'position'">{{
              scope.row.value | positionName
            }}</span>
          </template>
        </my-table>
        <van-pagination
          v-model="basePagination.page"
          :force-ellipses="true"
          @change="bDPaginationChange"
          :total-items="basePagination.total"
          :show-page-size="5"
        >
          <template #prev-text>
            <van-icon name="arrow-left" />
          </template>
          <template #next-text>
            <van-icon name="arrow" />
          </template>
          <template #page="{ text }">{{ text }}</template>
        </van-pagination>
        <h3>广告数据</h3>
        <!-- <van-field label="申请类型">
          <template #input>
            <van-button>总览</van-button>
            <van-button>触发器</van-button>
            <van-button>商店广告</van-button>
            <van-button></van-button>
          </template>
        </van-field> -->
        <date-selector
          v-model="adDate"
          @change="adDateChangeFn"
          :queryBtnClick="handleAdDateBtnClicked"
        ></date-selector>
        <my-table :tableData="adData" :tableField="adDataField">
          <template slot-scope="scope" slot="default">
            <span v-if="scope.row.key == 'position'">{{
              scope.row.value | positionName
            }}</span>
          </template>
        </my-table>
        <van-pagination
          v-model="adPagination.page"
          :force-ellipses="true"
          @change="aDPaginationChange"
          :total-items="adPagination.total"
          :show-page-size="5"
        >
          <template #prev-text>
            <van-icon name="arrow-left" />
          </template>
          <template #next-text>
            <van-icon name="arrow" />
          </template>
          <template #page="{ text }">{{ text }}</template>
        </van-pagination>
      </div>
    </div>
    <div class="updateBtnWrap">
      <van-button @click="buyServer">续费/升级</van-button>
    </div>
  </div>
</template>
<script>
import DateSelector from '../../components/m/DateSelector.vue';
import MyTable from '../../components/m/MyTable.vue';
import mixins from '../../mixins/data.mixins';
import { ONE_DAY, TO_DAY } from '../../base/CONST';
export default {
  components: {
    DateSelector,
    MyTable,
  },
  mixins: [mixins],
  data() {
    return {
      baseDate: [TO_DAY - 7 * ONE_DAY, TO_DAY],
      adDate: [TO_DAY - 7 * ONE_DAY, TO_DAY],
      baseDataField: [
        { label: '日期', prop: 'date' },
        { label: '', prop: '' },
        { label: '游戏人数', prop: 'player_count' },
        { label: '游戏总时长', prop: 'total_time' },
        { label: '游戏人均时长', prop: 'avg_time' },
        { label: '贡献点', prop: 'contribution' },
        { label: '迷你豆', prop: 'minibean' },
        { label: '付费人数', prop: 'pay_count' },
      ],
      adDataField: [
        { label: '日期', prop: 'date' },
        { label: '', prop: '' },
        { label: '广告总展示数', prop: 'ad_count' },
        { label: '广告总收入', prop: 'ad_income' },
        { label: '触发器广告展示', prop: 'trigger_count' },
        { label: '触发器广告收入', prop: 'trigger_income' },
        { label: '商店广告展示数', prop: 'shop_count' },
        { label: '商店广告收入', prop: 'shop_income' },
        { label: '通行证广告展示', prop: 'passcheck_count' },
        { label: '通行证广告收入', prop: 'passcheck_income' },
      ],
    };
  },
  methods: {
    buyServer() {
      //续费/升级埋点
      this.$log('renewal_upgrade_click', 85437, { v7: 2 });
      localStorage.setItem('renewItems', JSON.stringify([this.currServ]));
      this.$router.push({
        name: 'cloudServerBuy',
        params: { currServers: [this.currServ], type: 'renew' },
      });
    },
    handleBaseDateBtnClicked() {
      console.log('handleBaseDateBtnClicked---');
    },
    baseDateChangeFn(val) {
      console.log('baseDateChangeFn---', val);
    },
    handleAdDateBtnClicked() {
      console.log('handleAdDateBtnClicked---');
    },
    adDateChangeFn(val) {
      console.log('adDateChangeFn---', val);
    },
  },
};
</script>
<style src="../../style/common-m.scss" lang="scss" scoped></style>
<style>
.content {
  overflow: visible !important;
}
</style>
<style lang="scss" scoped>
.container {
  padding-bottom: 128px !important;
  position: relative;
}
.serverInfo {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-right: 16px;
  margin-bottom: 48px;
  img {
    width: 302px;
    height: 170px;
    background: #f2f2f2;
    border-radius: 11px;
    margin-right: 16px;
  }
  .serverDetails {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    h4 {
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
      line-height: 44px;
      text-align: left;
    }
    p {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #878d99;
      line-height: 34px;
      margin-top: 8px;
      text-align: left;
      &.remaindDay {
        color: #59d040;
      }
    }
  }
}
.serverDesc {
  margin: 30px auto 48px;
  ::v-deep .van-field {
    padding: 0;
  }
}
h3 {
  font-size: 36px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #262626;
  line-height: 52px;
  margin-bottom: 32px;
}
.serverDataList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 24px;
  .serverDataItem {
    width: 310px;
    height: 212px;
    background: #fafafa;
    border-radius: 12px;
    margin: 0 20px 20px 0;
    padding: 32px 0 32px 32px;
    &:nth-child(2n) {
      margin: 0;
    }
    h4 {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #878d99;
      line-height: 34px;
    }
    .itemVal {
      font-size: 36px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fd9b21;
      line-height: 50px;
      margin: 16px auto 14px;
      em {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262626;
        line-height: 28px;
        font-style: normal;
      }
    }
    .itemTotal {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 34px;
      em {
        font-style: normal;
      }
    }
  }
}
.updateBtnWrap {
  width: 750px;
  height: 128px;
  background: #fff;
  position: absolute;
  left: -10px;
  bottom: 0;
  .van-button {
    display: block;
    margin: 20px auto;
    width: 710px;
    height: 88px;
    background: #fd9b21ff;
    border-radius: 16px;
    font-size: 36px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff;
    line-height: 40px;
  }
}
.van-pagination {
  margin: 20px auto 30px;
}
</style>
